import React, { useState } from 'react';
import { useNavigate ,useLocation } from 'react-router-dom';
import BBimage from './images/BB.png';
import Worker from './images/Workerimage.png';
import Worker1 from './images/WorkerColourderimg.png';
import Builder from './images/Supplierimg.png';
import Builder1 from './images/Supplier.png';
import { BlinkitLoader } from './Component/Loader';

const RoleSelection = () => {
  const [selectedRole, setSelectedRole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); 
  const params = new URLSearchParams(location.search);
  const mode = params.get('mode'); 

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
  };

  const handleContinue = () => {
    if (selectedRole) {
      console.log('Selected role:', selectedRole);
      setIsLoading(true);
      
      // Simulate loading time before navigation
      setTimeout(() => {
        // Navigate based on selected role
        if (selectedRole === 'supplier') {
          window.location.href = '/supplier/login';
          setIsLoading(false) 
        } else if (selectedRole === 'builder') {
          navigate('/consumer');
        }
        setIsLoading(false);
      }, 1500);
    }
  };

  return (
    <div className="flex min-h-screen bg-white items-center justify-center">
      <div className="w-full max-w-2xl flex flex-col items-center justify-center px-6 py-8 mx-2">
        {/* Header with BB Image and Title */}
        <div className="flex flex-col items-center mb-6">
          <img
            src={BBimage}
            alt="BrickBucket"
            className="h-16 w-auto object-contain"
          />
          <h2 className="text-2xl font-semibold text-[#2B2A29] text-center mb-4">Brickbucket</h2>
          {mode === 'signin' && (
            <div className="text-2xl font-bold text-[#00000]">Sign In</div>
          )}
          {mode === 'signup' && (
            <div className="text-2xl font-bold text-[#00000]">Sign Up</div>
          )}
    
          <h1 className="text-xl  mt-6 text-start">
            <span className="font-medium text-[#00000]">Let's get started. </span>
            <span className="text-[#00000]">Tell us who you are.</span>
          </h1>
          <p className="text-xl text-gray-600 text-center"></p>
        </div>

        {/* Role Selection Boxes */}
        <div className="w-full">
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* Supplier Box */}
            <div
              className={`relative border rounded-lg p-8 cursor-pointer transition-all duration-200 flex-1 h-47 ${
                selectedRole === 'supplier'
                  ? 'border-[#D93025] bg-[#FFFFFF]'
                  : 'border-gray-300 bg-white '
              }`}
              onClick={() => handleRoleSelection('supplier')}
            >
              {/* Checkbox */}
              <div className="absolute bottom-2 right-4">
                <div className={`w-5 h-5 rounded border flex items-center justify-center ${
                  selectedRole === 'supplier'
                    ? 'border-[#D93025] bg-[#D93025]'
                    : 'border-gray-300 bg-white'
                }`}>
                  {selectedRole === 'supplier' && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </div>
              {/* Image */}
              <div className="flex justify-center mb-2 mt-2">
                <img
                  src={selectedRole === 'supplier' ? Builder : Builder1}
                  alt="Supplier"
                  className="h-14 w-14 object-contain"
                />
              </div>
              {/* Label */}
              <div className="text-center">
                <h3 className={`text-md font-bold ${
                  selectedRole === 'supplier' ? 'text-[#D93025]' : 'text-[#AAA7A7]'
                }`}>
                  Supplier
                </h3>
              </div>
            </div>

            {/* Builder Box */}
            <div
              className={`relative border rounded-lg p-8 cursor-pointer transition-all duration-200 flex-1  h-47 ${
                selectedRole === 'builder'
                  ? 'border-[#D93025] bg-[#FFFFFF]'
                  : 'border-gray-300 bg-white '
              }`}
              onClick={() => handleRoleSelection('builder')}
            >
              {/* Checkbox */}
              <div className="absolute bottom-2 right-4">
                <div className={`w-5 h-5 rounded border flex items-center justify-center ${
                  selectedRole === 'builder'
                    ? 'border-[#D93025] bg-[#D93025]'
                    : 'border-gray-300 bg-white'
                }`}>
                  {selectedRole === 'builder' && (
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </div>
              {/* Image */}
              <div className="flex justify-center mb-4 mt-2">
                <img
                  src={selectedRole === 'builder' ? Worker1 : Worker}
                  alt="Builder"
                  className="h-14 w-14 object-contain"
                />
              </div>
              {/* Label */}
              <div className="text-center">
                <h3 className={`text-md font-bold ${
                  selectedRole === 'builder' ? 'text-[#D93025]' : 'text-[#AAA7A7]'
                }`}>
                  Builder
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Continue Button */}
        <div className="w-full mt-12">
  <div className="flex justify-end">
    <button
      onClick={handleContinue}
      disabled={!selectedRole || isLoading}
      className={`px-8 py-3 rounded-lg font-medium transition-all duration-200 ${
        selectedRole && !isLoading
          ? 'bg-[#D93025] text-white cursor-pointer'
          : 'cursor-not-allowed'
      }`}
      style={!selectedRole && !isLoading ? {
        backgroundColor: '#E47A7A2B', // 17% opacity
        color: '#D93025BA' // 73% opacity
      } : {}}
    >
      {isLoading ? 'Please wait...' : 'Continue'}
    </button>
  </div>
</div>


        {/* Loader Overlay */}
        {isLoading && (
          <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
            <div className="text-center">
              <BlinkitLoader text="Setting up your account..." />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoleSelection;
